import type { Vec2 } from './types.js';

export const vec2 = {
  zero(): Vec2 {
    return { x: 0, y: 0 };
  },
  clone(v: Vec2): Vec2 {
    return { x: v.x, y: v.y };
  },
  add(a: Vec2, b: Vec2): Vec2 {
    return { x: a.x + b.x, y: a.y + b.y };
  },
  sub(a: Vec2, b: Vec2): Vec2 {
    return { x: a.x - b.x, y: a.y - b.y };
  },
  scale(a: Vec2, s: number): Vec2 {
    return { x: a.x * s, y: a.y * s };
  },
  length(a: Vec2): number {
    return Math.sqrt(a.x * a.x + a.y * a.y);
  },
  normalize(a: Vec2): Vec2 {
    const len = Math.sqrt(a.x * a.x + a.y * a.y);
    if (len === 0) return { x: 0, y: 0 };
    return { x: a.x / len, y: a.y / len };
  },
  dot(a: Vec2, b: Vec2): number {
    return a.x * b.x + a.y * b.y;
  },
};

export function clamp(v: number, lo: number, hi: number): number {
  if (v < lo) return lo;
  if (v > hi) return hi;
  return v;
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function deg2rad(deg: number): number {
  return (deg * Math.PI) / 180;
}

export function rad2deg(rad: number): number {
  return (rad * 180) / Math.PI;
}

export function distSq(a: Vec2, b: Vec2): number {
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  return dx * dx + dy * dy;
}
